<template>
    <cadastro-simples-list
        endpoint="grupo-pontuacao-professor"
        rota-base="/admin/grupo-pontuacao-professor"
        titulo="GRUPOS DE PONTUAÇÃO DE PROFESSOR"
        titulo-singular="Grupo de Pontuação de Professor"
        :colunas-extras='[{"campo":"descricao","label":"Descrição","tipo":"text","span":24}]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
